import { documentService } from '../../services/documentService';

/**
 * Twin objects matching `q`, as `{entity_id, name}`. The suggest endpoint
 * returns raw attributes and each type names itself differently — a person by
 * `full_name`, an agreement by its number, an animal by its ear tag — so the
 * display name falls through them in order, ending at the id.
 */
export async function fetchEntitySuggestions(entityType: string, q: string, limit = 8) {
  const result = await documentService.suggestEntities(entityType, q, limit);
  return result.items.map((item) => {
    const row = item as {
      entity_id?: unknown;
      name?: string;
      full_name?: string;
      agreement_number?: string;
      ear_tag?: string;
    };
    return {
      entity_id: String(row.entity_id ?? ''),
      name: String(row.name ?? row.full_name ?? row.agreement_number ?? row.ear_tag ?? row.entity_id ?? ''),
    };
  });
}
